import {APIMethod} from '@enums'

import {fetchData} from 'api/api'

import {ContractTypeRequest, ContractTypeResponse} from './types'

/**
 * @returns All Contract Types for the current user's company
 */
export const getContractTypesByCompany = async (companyId: string): Promise<ContractTypeResponse[]> => {
  return fetchData({
    method: APIMethod.GET,
    url: `contract-type/company/${companyId}`,
  })
}

/**
 * @param id Contract Type ID
 * @returns A single Contract Type with a specific ID
 */
export const getContractType = async (id: string): Promise<ContractTypeResponse> => {
  return fetchData({
    method: APIMethod.GET,
    url: `contract-type/${id}`,
  })
}

/**
 * Updates an existing Contract Type
 * @param id Contract Type ID
 * @param body Contract Type payload data
 * @returns Updated Contract Type data
 */
export const updateContractType = async (id: string, body: ContractTypeRequest): Promise<ContractTypeResponse> => {
  return fetchData({
    method: APIMethod.PUT,
    url: `contract-type/${id}`,
    body,
  })
}

/**
 * Creates a new Contract Type
 * @param body Contract Type payload data
 * @returns New Contract Type data
 */
export const createContractType = async (body: ContractTypeRequest): Promise<ContractTypeResponse> => {
  return fetchData({
    method: APIMethod.POST,
    url: `contract-type`,
    body,
  })
}

/**
 * @returns Only contract type names for dropdowns etc.
 */
export const getContractTypeNames = async (): Promise<string[]> => {
  return fetchData({
    method: APIMethod.GET,
    url: 'api/hubspot/metadata/contract-types',
  })
}
